import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, inject, DestroyRef} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

@Component({
    selector: 'app-search-box',
    templateUrl: './search-box.component.html',
    styleUrls: ['./search-box.component.scss'],
    standalone: false
})
export class SearchBoxComponent  implements OnInit {

  @ViewChild('searchInput') searchInput: ElementRef;
  @Input() placeholder;
  @Input() searchText;
  @Output() changed = new EventEmitter();
  searchFilter: Subject<string> = new Subject<string>();
private destroyRef = inject(DestroyRef);
  constructor() {
    
    this.searchFilter.pipe(
      debounceTime(500),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(search =>
      this.changed.emit(search)
    );
  }

  ngOnInit(): void {
    if (this.searchText?.length > 0) {
      this.searchFilter.next(this.searchText);
    }
    if (!this.placeholder) {
      this.placeholder = 'SEARCH.PLACE_HOLDER';
    }
  }

  onKeyUp(text): void {
    this.searchFilter.next(text.target.value);
    this.searchText = text.target.value;
  }

  clearInput(): void {
    if (this.searchInput.nativeElement.value) {
      this.searchInput.nativeElement.value = '';
      const event = new KeyboardEvent('keyup',{bubbles:true, key: 'Backspace', code: 'Backspace'});
      this.searchInput.nativeElement.dispatchEvent(event);
    }
  }
}
